/**
 * DepthSort — 2.5D layering. Entities are drawn in order of their ground Y so
 * those "closer" to the camera (larger Y) render in front. Decoupled from the
 * entities themselves via a minimal interface so the ordering rule is testable.
 */

export interface DepthSortable {
  /** Y of the entity's feet on the ground plane (NOT its visual/jumped Y). */
  readonly groundY: number;
  setDepth(value: number): unknown;
}

/** Pure: the render depth for a given ground Y (larger Y = nearer = on top). */
export function depthForGroundY(groundY: number): number {
  return groundY;
}

/** Pure comparator — ascending ground Y (back-to-front draw order). */
export function compareByGroundY(a: DepthSortable, b: DepthSortable): number {
  return a.groundY - b.groundY;
}

export class DepthSort {
  private readonly entities: DepthSortable[] = [];

  register(e: DepthSortable): void {
    this.entities.push(e);
  }

  unregister(e: DepthSortable): void {
    const i = this.entities.indexOf(e);
    if (i >= 0) this.entities.splice(i, 1);
  }

  /** Assign each entity a depth equal to its ground Y. Call once per frame. */
  update(): void {
    for (const e of this.entities) {
      e.setDepth(depthForGroundY(e.groundY));
    }
  }

  clear(): void {
    this.entities.length = 0;
  }
}
